import { c as _c } from "react/compiler-runtime";
import React, { type ReactElement } from 'react';
import { StyledBoxChevronContainer, StyledCollapseNavItemChildren, StyledDivNavItemHeader, StyledGridNavContentSubItemContainer, StyledListItemNavItem, StyledListNavContentContainer } from './styles';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { type NavContentItemWithChildren as TNavContentItemWithChildren, type NavContentItemWithoutChildren as TNavContentItemWithoutChildren, type NavContentProps, type NavContentWithChildrenItemProps, type NavContentWithoutChildrenItemProps, type NavContentSubItemProps } from './types';
import { CheckIcon } from '../icons/CheckIcon';
import { ChevronDownIcon } from '../icons/ChevronDownIcon';
import { ChevronUpIcon } from '../icons/ChevronUpIcon';
import { CollapseLeftIcon } from '../icons/CollapseLeftIcon';
import { ExpandRightIcon } from '../icons/ExpandRightIcon';
import { LockIcon } from '../icons/LockIcon';
import Grid from '../Grid';
import Typography from '../Typography';
const NavContent = t0 => {
  const $ = _c(23);
  const {
    content,
    selectedIndex,
    selectedChildIndex,
    isNavBarOpen,
    handleNavBarToggle,
    handleContentItemWithChildrenToggle,
    expandedIndexes
  } = t0;
  let t1;
  if ($[0] !== isNavBarOpen) {
    t1 = <ListItemIcon>{isNavBarOpen ? <CollapseLeftIcon /> : <ExpandRightIcon />}</ListItemIcon>;
    $[0] = isNavBarOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ListItemText primary="Hide Menu" primaryTypographyProps={{
      variant: "body3"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleNavBarToggle || $[4] !== t1) {
    t3 = <StyledListItemNavItem><ListItemButton onClick={handleNavBarToggle}>{t1}{t2}</ListItemButton></StyledListItemNavItem>;
    $[3] = handleNavBarToggle;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== content || $[7] !== expandedIndexes || $[8] !== handleContentItemWithChildrenToggle || $[9] !== isNavBarOpen || $[10] !== selectedChildIndex || $[11] !== selectedIndex) {
    let t5;
    if ($[13] !== expandedIndexes || $[14] !== handleContentItemWithChildrenToggle || $[15] !== isNavBarOpen || $[16] !== selectedChildIndex || $[17] !== selectedIndex) {
      t5 = (item, index) => {
        if ((item as TNavContentItemWithChildren).subItems != null) {
          return <NavContentItemWithChildren key={`${item.label}-${index}`} {...item} isSelected={index === selectedIndex} selectedChildIndex={selectedChildIndex} isNavBarOpen={isNavBarOpen} handleContentItemWithChildrenToggle={handleContentItemWithChildrenToggle} isExpanded={expandedIndexes.includes(index)} index={index} />;
        } else {
          return <NavContentItemWithoutChildren key={`${item.label}-${index}`} {...item as TNavContentItemWithoutChildren} isSelected={index === selectedIndex} />;
        }
      };
      $[13] = expandedIndexes;
      $[14] = handleContentItemWithChildrenToggle;
      $[15] = isNavBarOpen;
      $[16] = selectedChildIndex;
      $[17] = selectedIndex;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    t4 = content.map(t5);
    $[6] = content;
    $[7] = expandedIndexes;
    $[8] = handleContentItemWithChildrenToggle;
    $[9] = isNavBarOpen;
    $[10] = selectedChildIndex;
    $[11] = selectedIndex;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[19] !== isNavBarOpen || $[20] !== t3 || $[21] !== t4) {
    t5 = <StyledListNavContentContainer open={isNavBarOpen}>{t3}{t4}</StyledListNavContentContainer>;
    $[19] = isNavBarOpen;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
};
const NavContentItemWithoutChildren = t0 => {
  const $ = _c(19);
  const {
    label,
    Link,
    path,
    IconComponent,
    isSelected,
    locked
  } = t0;
  let t1;
  if ($[0] !== IconComponent || $[1] !== locked) {
    t1 = locked === true ? <LockIcon /> : IconComponent;
    $[0] = IconComponent;
    $[1] = locked;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <ListItemIcon>{t1}</ListItemIcon>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      variant: "h5"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== label) {
    t4 = <ListItemText primary={label} primaryTypographyProps={t3} />;
    $[6] = label;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <ListItemButton>{t2}{t4}</ListItemButton>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== Link || $[12] !== path || $[13] !== t5) {
    t6 = <Link href={path}>{t5}</Link>;
    $[11] = Link;
    $[12] = path;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isSelected || $[16] !== locked || $[17] !== t6) {
    t7 = <StyledListItemNavItem isLocked={locked} isSelected={isSelected}>{t6}</StyledListItemNavItem>;
    $[15] = isSelected;
    $[16] = locked;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
const NavContentItemWithChildren = t0 => {
  const $ = _c(45);
  const {
    label,
    IconComponent,
    subItems: t1,
    selectedChildIndex,
    isSelected,
    isExpanded,
    isNavBarOpen,
    handleContentItemWithChildrenToggle,
    index,
    locked
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const subItems = t2;
  let t3;
  if ($[2] !== handleContentItemWithChildrenToggle || $[3] !== index) {
    t3 = () => {
      handleContentItemWithChildrenToggle(index);
    };
    $[2] = handleContentItemWithChildrenToggle;
    $[3] = index;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClick = t3;
  const t4 = isExpanded && isNavBarOpen;
  let t5;
  if ($[5] !== IconComponent || $[6] !== locked) {
    t5 = locked === true ? <LockIcon /> : IconComponent;
    $[5] = IconComponent;
    $[6] = locked;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <ListItemIcon>{t5}</ListItemIcon>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      variant: "h5"
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== label) {
    t8 = <ListItemText primary={label} primaryTypographyProps={t7} />;
    $[11] = label;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isExpanded) {
    t9 = isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />;
    $[13] = isExpanded;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isNavBarOpen || $[16] !== t9) {
    t10 = <StyledBoxChevronContainer isNavBarOpen={isNavBarOpen}>{t9}</StyledBoxChevronContainer>;
    $[15] = isNavBarOpen;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== handleClick || $[19] !== t10 || $[20] !== t6 || $[21] !== t8) {
    t11 = <ListItemButton onClick={handleClick}>{t6}{t8}{t10}</ListItemButton>;
    $[18] = handleClick;
    $[19] = t10;
    $[20] = t6;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isSelected || $[24] !== locked || $[25] !== t11 || $[26] !== t4) {
    t12 = <StyledDivNavItemHeader isSelected={isSelected} isExpanded={t4} isLocked={locked}>{t11}</StyledDivNavItemHeader>;
    $[23] = isSelected;
    $[24] = locked;
    $[25] = t11;
    $[26] = t4;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = isExpanded && isNavBarOpen;
  const t14 = isExpanded && isNavBarOpen;
  let t15;
  if ($[28] !== isSelected || $[29] !== selectedChildIndex || $[30] !== subItems) {
    let t16;
    if ($[32] !== isSelected || $[33] !== selectedChildIndex) {
      t16 = (item, index_0) => <NavContentItemChild key={`${item.label}-${item.path}`} {...item} isSelected={isSelected && selectedChildIndex === index_0} />;
      $[32] = isSelected;
      $[33] = selectedChildIndex;
      $[34] = t16;
    } else {
      t16 = $[34];
    }
    t15 = subItems.map(t16);
    $[28] = isSelected;
    $[29] = selectedChildIndex;
    $[30] = subItems;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[35] !== t15) {
    t16 = <Grid paddingTop="4px" gap="2px" paddingBottom="12px" display="flex" flexDirection="column">{t15}</Grid>;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== isSelected || $[38] !== t13 || $[39] !== t14 || $[40] !== t16) {
    t17 = <StyledCollapseNavItemChildren in={t13} open={t14} isSelected={isSelected}>{t16}</StyledCollapseNavItemChildren>;
    $[37] = isSelected;
    $[38] = t13;
    $[39] = t14;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t12 || $[43] !== t17) {
    t18 = <li>{t12}{t17}</li>;
    $[42] = t12;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};
const NavContentItemChild = t0 => {
  const $ = _c(14);
  const {
    label,
    Link,
    path,
    isSelected,
    locked
  } = t0;
  let t1;
  if ($[0] !== locked) {
    t1 = <Grid width="24px" height="24px" display="block" flexShrink={0}>{locked === true ? <LockIcon /> : <CheckIcon />}</Grid>;
    $[0] = locked;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isSelected ? "h5" : "body2";
  let t3;
  if ($[2] !== label || $[3] !== t2) {
    t3 = <Typography variant={t2} title={label}>{label}</Typography>;
    $[2] = label;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isSelected || $[6] !== locked || $[7] !== t1 || $[8] !== t3) {
    t4 = <StyledGridNavContentSubItemContainer isLocked={locked} isSelected={isSelected}>{t1}{t3}</StyledGridNavContentSubItemContainer>;
    $[5] = isSelected;
    $[6] = locked;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== Link || $[11] !== path || $[12] !== t4) {
    t5 = <Link href={path}>{t4}</Link>;
    $[10] = Link;
    $[11] = path;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default NavContent;